class OrderItem extends HTMLElement {
  constructor() {
    super();
  }

  /**
   * finds and assigns pricing for item
   * @param {*} param0 
   * @param {number} param0.sellPrice - used price
   * @param {number} param0.newPrice - item msrp price
   */
  createPriceElement({ sellPrice, newPrice }) {
    const salePriceEl = this.querySelector('.sell-price');
    const newPriceEl = this.querySelector('.new-price');
    salePriceEl.textContent = `${sellPriceText} ${formatMoney(sellPrice)}`;
    if (newPriceEl) {
      newPriceEl.textContent = `${newPriceText} ${formatMoney(newPrice)}`;
    }
  }

  /**
   * assigns item details to the appropriate elements
   * @param {*} param0 
   * @param {string} param0.parentSku - parent sku of the item
   * @param {string} param0.title - item title
   * @param {string} param0.notes - item notes
   * @param {string} param0.color - item color
   * @param {string} param0.condition - item condition
   * @param {string} param0.size - item size
   */
  renderDetails({ parentSku, title, notes, color, condition, size}) {
    const itemNameEl = this.querySelector('.cart__item-details .item-name');
    itemNameEl.textContent = title;
    const itemSkuEl = this.querySelector('.cart__item-details .item-sku');
    itemSkuEl.textContent = parentSku === '<unknown>' ? '' :  `${itemNumberLabel} ${parentSku}`;
    const colorTag = this.querySelector('.item-color');
    colorTag.textContent = color || '';
    const sizeTag = this.querySelector('.item-size');
    sizeTag.textContent = size || '';
    const conditionTag = this.querySelector('.item-condition');
    conditionTag.textContent = condition || '';
    const itemDetailsEl = this.querySelector('.cart__item-details .item-details');
    itemDetailsEl.appendChild(colorTag);
    itemDetailsEl.appendChild(sizeTag);
    itemDetailsEl.appendChild(conditionTag);
    const itemNotes = this.querySelector('.cart__item-details .item-notes');
    itemNotes.textContent = notes || '';
  }

  /**
   * renders cart item
   * @param {*} item
   */
  renderItem(item) {
    const imageContainer = document.createElement('div');
    imageContainer.classList.add('cart__item-list-body', 'cart__item-media');

    const imageElement = document.createElement('img');
    window.IMAGE_UTILS.setElementImage({
      imgUrl: item.inventoryItem.images[0]?.url,
      imageElement,
      imgOptions: { width: '100', height: '200' },
      altText: item.inventoryItem.catalogItem.title,
    })
    imageContainer.appendChild(imageElement);

    this.appendChild(imageContainer);

    this.setAttribute('uuid', item.uuid);
    this.renderDetails({
      parentSku: item.inventoryItem.catalogItem.parentSku,
      title: item.inventoryItem.catalogItem.title,
      notes: item.salesNotes,
      color: item.inventoryItem.color.displayName,
      size: item.inventoryItem.size.displayName,
      condition: item.inventoryItem.condition.displayName,
    });
    this.createPriceElement({
      sellPrice: item.salePrice,
      newPrice: item.inventoryItem.catalogItem.price,
    });
  }

}

customElements.define('order-item', OrderItem);
